<template>
  <div class="creative-desc">
    <ColumnBlock
      :title="title"
      :configable="!isEnableStarTaskOriginVideoTitle && !isLiveMaterial"
      :clearable="!isEnableStarTaskOriginVideoTitle && !isLiveMaterial"
      @clear="onClear"
      @show-config-modal="onShowConfigModal"
    >
      <div slot="title" class="block-title">
        <h4>{{ props.title }}</h4>
        <span v-if="!isEnableStarTaskOriginVideoTitle && !isLiveMaterial">{{ configForm.descriptions.length }}/50 </span>
      </div>
      <div class="star-task-placeholder" v-if="isEnableStarTaskOriginVideoTitle">无需配置</div>
      <div class="live-material-placeholder" v-else-if="isLiveMaterial">无需配置</div>
      <div v-else class="desc-items">
        <div v-for="(item, index) in descriptions" :key="item.targetingId" class="desc-item">
          <span>{{ item.packName }}</span>
          <em @click="onDescItemRemove(index)" class="close-icon el-icon-error"></em>
        </div>
      </div>
    </ColumnBlock>

    <TitleSelectModal v-model="showDescInfoModal" :op-id="opId" @confirm="onTitleSelectorConfirm" />
  </div>
</template>

<script setup>
import { computed, ref, toRefs, inject } from 'vue'
import ColumnBlock from '../layout/block.vue'
import ConfigDrawer from '../layout/drawer.vue'
import { MATERIAL_STYLE } from '../../consts/index'
import TitleSelectModal from '@/components/title-selector/title-selector-modal.vue'

const { opId } = inject('localStates')

// eslint-disable-next-line
const props = defineProps({
  title: String
})
const { title } = toRefs(props)

const { configForm, updateConfigForm } = inject('configForm')
const { isV3 } = inject('bytedanceVersion', { isV3: computed(() => false) })
const descriptions = computed(() => configForm.value.descriptions)

// 项目是否关联星广联投任务
const isRelatedStarTask = computed(() => !!configForm.value.project.star_task?.star_task_id)
const isLiveMaterial = computed(() => configForm.value.plan.materials_type === MATERIAL_STYLE.LIVE_MATERIALS)
// 关联星广联投任务且开启自动优选素材且使用原视频标题
const isEnableStarTaskOriginVideoTitle = computed(() => {
  const { plan, project } = configForm.value
  return !isV3.value && isRelatedStarTask.value && project.star_auto_material_addition_switch === 'ON' && plan.original_video_title === 'ON'
})

function onTitleSelectorConfirm(e) {
  const existIds = descriptions.value.map((item) => item.id)
  const newRows = {}

  for (const item of e) {
    if (existIds.includes(item.id)) continue
    if (newRows[item.id]) continue
    newRows[item.id] = item
  }
  const newRowsArr = Object.values(newRows)
  updateConfigForm({
    ...configForm.value,
    descriptions: descriptions.value.concat(newRowsArr).slice(0, 100)
  })
}

const showDescInfoModal = ref(false)
function onDescItemRemove(index) {
  const descs = descriptions.value.filter((item, i) => i !== index)

  updateConfigForm({
    ...configForm.value,
    descriptions: descs
  })
}
function onShowConfigModal() {
  showDescInfoModal.value = true
}
function onClear() {
  updateConfigForm({
    ...configForm.value,
    descriptions: []
  })
}
</script>

<style lang="scss" scoped>
.desc-preview {
  height: 380px;
  overflow: auto;
}
.config-count {
  font-size: 14px;
  margin-left: 20px;
}

.star-task-placeholder,
.live-material-placeholder {
  height: 380px;
  line-height: 380px;
  text-align: center;
}

.creative-desc {
  .desc-items {
    padding: 10px;
    height: 380px;
    overflow: auto;
  }

  .desc-item {
    display: flex;
    padding: 6px 10px;
    justify-content: space-between;
    align-items: center;
    background: #eee;
    margin-bottom: 10px;
    border-radius: 4px;
  }

  .close-icon {
    cursor: pointer;
    font-size: 13px;
  }
}
</style>
